'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { useEffect, useState } from 'react';
import { Button } from '@module/mdrt-org/shared/components/button/button';
import { Dialog } from '@module/mdrt-org/shared/components/dialog/dialog';
import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { isMobileUserAgent } from '@module/mdrt-org/shared/utils/helpers/is-mobile-device';
import { loginHandler } from '@module/mdrt-org/shared/utils/helpers/login-handler';
import { useAdB2cObjectId } from '@module/mdrt-org/shared/utils/hooks/use-ad-b2c-object-id';
import { AuthProviderName } from '@shared/misc/next-auth/enum';
import { parseJwtToken } from '@shared/misc/utils/parse-jwt-token';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import { ModalTrigger } from '@shared/ui-components/modal/modal';
import { BiometricIdIcon } from '@shared/ui-components/svgs/';
import { useMounted } from '@shared/utils/hooks/use-mounted';
import { type BiometricAuthenticationModalContent } from './get-biometric-id-content';
import { isBiometricAuthenticationDismissed, onDismissBiometricAuthenticationModal } from './utils/biometric-auth-utils';
import styles from './biometric-id-modal.module.scss';
type BiometricIdModalProps = {
  cmsContent: BiometricAuthenticationModalContent;
};
export const BiometricIdModal = t0 => {
  const $ = _c(19);
  const {
    cmsContent
  } = t0;
  const locale = useLocale();
  const {
    accessToken
  } = useUserContext();
  const userId = useAdB2cObjectId();
  let t1;
  if ($[0] !== accessToken) {
    t1 = accessToken ? parseJwtToken(accessToken) : undefined;
    $[0] = accessToken;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const parsedToken = t1;
  const isModalComponentMounted = useMounted();
  let t2;
  if ($[2] !== isModalComponentMounted || $[3] !== parsedToken) {
    t2 = typeof navigator !== "undefined" && isMobileUserAgent(navigator.userAgent) && isModalComponentMounted && !isBiometricAuthenticationDismissed() && parsedToken !== undefined && (parsedToken?.idp === undefined || parsedToken?.idp !== "fido");
    $[2] = isModalComponentMounted;
    $[3] = parsedToken;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const shouldModalBeOpened = t2;
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t3;
  let t4;
  if ($[5] !== shouldModalBeOpened) {
    t3 = () => {
      setIsModalOpen(shouldModalBeOpened);
    };
    t4 = [shouldModalBeOpened];
    $[5] = shouldModalBeOpened;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== cmsContent.disableMessage || $[9] !== cmsContent.dismiss || $[10] !== cmsContent.enable || $[11] !== cmsContent.heading || $[12] !== cmsContent.loginMessage || $[13] !== locale || $[14] !== userId) {
    t5 = () => <Dialog><div className={styles.modal}><div className={styles.modal__icon}><BiometricIdIcon /></div><div className={styles["modal__content-wrapper"]}><p className={styles.modal__header}>{cmsContent.heading}</p><p className={styles.modal__content}>{cmsContent.loginMessage}</p><p className={styles.modal__content}>{cmsContent.disableMessage}</p></div><div className={styles.divider} /><div className={styles.modal__footer}><Button onClick={() => {
            onDismissBiometricAuthenticationModal();
            setIsModalOpen(false);
          }} variant={ButtonVariant.Secondary}>{cmsContent.dismiss}</Button><Button onClick={() => loginHandler({
            authorizationParameters: {
              ui_locales: locale,
              userId
            },
            provider: AuthProviderName.BiometricRegistration
          })}>{cmsContent.enable}</Button></div></div></Dialog>;
    $[8] = cmsContent.disableMessage;
    $[9] = cmsContent.dismiss;
    $[10] = cmsContent.enable;
    $[11] = cmsContent.heading;
    $[12] = cmsContent.loginMessage;
    $[13] = locale;
    $[14] = userId;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== isModalOpen || $[17] !== t5) {
    t6 = <ModalTrigger isOpen={isModalOpen}>{t5}</ModalTrigger>;
    $[16] = isModalOpen;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};